export default {
    storedCities: [],
};